import { Component, OnInit, Input, Inject } from '@angular/core';
import { IntroConfigurations } from "./intro.configurations";
import { TitleLineConfigurations } from "../title/title.configurations";
import { KlaHttpService } from "../services/kla.http.service";
import { SubPackage, PackageDetails } from "../services/kla.data.models";
import { CommonModule } from '@angular/common';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';
import { AnimateArrowOnHoverDirective } from 'app/shared/tools/arrow-animations/animate-arrow-on-hover.directive';

@Component({
  selector: 'kla-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, DynamicContentComponent, AnimateArrowOnHoverDirective ]
})
export class IntroComponent implements OnInit {

  @Input()
  public details: PackageDetails;

  @Input()
  public config: IntroConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public subPackages: Array<SubPackage>=[];

  public categorySlug: string;
  public imagePath: string;
  public description: string;

  constructor(
      private httpService: KlaHttpService) {}

  ngOnInit() {
    this.categorySlug = this.config.title.replace(/ /g, '-').toLowerCase();
    this.imagePath = this.httpService.getImagePath(this.config.backgroundImage, 1500);
    this.description = this.config.description ? this.config.description : this.details.description;
  }

  scrollToSection($event, el) {
    const pageFragment = document.querySelector(`.page-fragment-${el}`);
      $event.preventDefault();
      if (pageFragment) {
      pageFragment.scrollIntoView({behavior: "smooth"});
      }
  }
}
